import AIReducer from "@/slices/AI-Infor/AIReducer";
import popupReducer from "@/slices/Popup/popupReducer";
import ableButtonReducer from "@/slices/ableButton/ableButtonReducer";
import AlertReducer from "@/slices/alert/AlertReducer";
import authReducer from "@/slices/auth/authReducer";
import changeThemeReducer from "@/slices/changeTheme/changeThemeReducer";
import DashboardReducer from "@/slices/dashboard/DashboardReducer";
import firebaseReducer from "@/slices/firebase/firebaseReducer";
import MenuReducer from "@/slices/menu/MenuReducer";
import { combineReducers } from "@reduxjs/toolkit";

export const rootReducerName = {
  auth: "auth",
  firebase: "firebase",
  ai: "ai",
  dashboard: "dashboard",
  menus: "menus",
  alert: "alert",
  popup: "popup",
  ableButton: "ableButton",
  changeTheme: "changeTheme"
};

export const rootReducer = combineReducers({
  [rootReducerName.auth]: authReducer,
  [rootReducerName.firebase]: firebaseReducer,
  [rootReducerName.ai]: AIReducer,
  [rootReducerName.dashboard]: DashboardReducer,
  [rootReducerName.menus]: MenuReducer,
  [rootReducerName.alert]: AlertReducer,
  [rootReducerName.popup]: popupReducer,
  [rootReducerName.ableButton]: ableButtonReducer,
  [rootReducerName.changeTheme]: changeThemeReducer
});
